
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";

interface Props {
  show: boolean
  onHide: () => void
  onOpenImporter1: () => void
  onOpenImporter2: () => void
}

const TasksImporterSelector = ({ show, onHide, onOpenImporter1, onOpenImporter2 }: Props) => {

  const handleClose = () => {
    onHide()
  }

  const openGanttImporter = () => {
    onOpenImporter1()
    handleClose()
  }

  const openPullPlanningImporter = () => {
    onOpenImporter2()
    handleClose()
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="sm"
    >
      <Modal.Header closeButton>
        <Modal.Title>Importar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Seleccione el formato de importación</p>
        <Row className="pb-2">
          <Col>
            <button className="btn btn-normal-2 btn-block" onClick={openPullPlanningImporter}>
              Pull Planning
            </button>
          </Col>
        </Row>
        <Row>
          <Col>
            <button className="btn btn-normal-2 btn-block" onClick={openGanttImporter}>
              Gantt
            </button>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link btn-link-header" onClick={handleClose}>
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default TasksImporterSelector
